import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64399ae4")

_pushScopeId("data-v-64399ae4")
const _hoisted_1 = {
  key: 0,
  ref: "mapContainer",
  style: {"width":"100%","height":"400px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, null, 512))
    : _createCommentVNode("", true)
})